import watch from 'redux-watch';
import shopListTpl from './shop-list.tpl.html!text';

class ShopListCtrl {
    constructor($scope, $anchorScroll, $state, $filter, shopListServ, storeServ, helperServ) {

        this.$scope = $scope;
        this.$anchorScroll = $anchorScroll;
        this.$state = $state;
        this.$filter = $filter;
        this.shopListServ = shopListServ;
        this.storeServ = storeServ;
        this.helperServ = helperServ;

        this.shops = [];

        this.ngOnInit();
    }

    ngOnInit() {
        this.subscribeToStore();
        
        this.$scope.$on('$destroy', this.ngOnDestroy.bind(this));
    }

    subscribeToStore() {
        let watchShopsInBounds = watch(this.storeServ.getState, 'shopsInBounds');

        this.stopWatchingShopsInBounds = this.storeServ.subscribe(watchShopsInBounds((shopsInBounds, oldShopsInBounds, objectPath) => {
            if (shopsInBounds) {
                shopsInBounds = this.shopListServ.filterShopsInHighlightedBounds(shopsInBounds);

                shopsInBounds = this.shopListServ.sanitizeShopProperties(shopsInBounds);

                this.shops = shopsInBounds;
            } else {
                this.shops = [];
            }
        }));
    }
    
    goToShopDetailsPage(shop) {
        let district = shop.district;
        let city = shop.city;
        let name = shop.prettyName;
        let code = shop.pos;

        this.$state.go('shop-details', {
            district,
            city,
            name,
            code
        });
    }

    setShopToHighlightPosCode(posCode) {
        this.storeServ.dispatch({
            type: 'TRIGGER_CLICK_ON_MARKER',
            posCode: posCode.toString()
        });

        this.$anchorScroll();
    }

    ngOnDestroy() {
        this.stopWatchingShopsInBounds();

        this.storeServ.getState().triggerClickOnMarker && this.storeServ.dispatch({
            type: 'TRIGGER_CLICK_ON_MARKER',
            posCode: null
        });
    }
}

ShopListCtrl.$inject = ['$scope', '$anchorScroll', '$state', '$filter', 'shopListServ', 'storeServ', 'helperServ'];

var shopListDirective = function() {
 	return {
 		restrict: 'E',
 		replace: true,
 		transclude: true,
 		template: shopListTpl,
 		scope: {},
 		controller: ShopListCtrl,
 		controllerAs: 'ctrl'
 	};
 };

 export default shopListDirective;